import { render, staticRenderFns } from "./QA_bd.vue?vue&type=template&id=d0623dd4&scoped=true&"
import script from "./QA_bd.vue?vue&type=script&lang=js&"
export * from "./QA_bd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0623dd4",
  null
  
)

export default component.exports